import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import WorkspaceContainer, {WorkspaceName} from "../table/workspace/WorkspaceContainer";
import SortColumnModel from "../../../model/workspace/SortColumnModel";
import {none, Option, option} from "ts-option";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {api} from "../../../api/api";
import UploadAssetModal from "../../admin/assets/modal/UploadAssetModal";
import DownloadAssetMaterialsModal from "../../admin/assets/modal/assetMaterials/DownloadAssetMaterialsModal";
import UploadAssetMaterialsModal from "../../admin/assets/modal/assetMaterials/UploadAssetMaterialsModal";
import Routes from "../../../navigation/route/Route";
import {CellInfo} from "react-table";
import AssetMaterialsBreakdownModal from "../../admin/assets/modal/assetMaterials/AssetMaterialsBreakdownModal";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {WildcardFilterColumnType} from "../../../model/workspace/WildcardFilter";
import AssetHistoryModal from "../../admin/assets/modal/AssetHistoryModal";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

interface IState {
	/**
	 * Indicates if upload asset modal is visible
	 */
	uploadModalVisible: boolean;
	/**
	 * Indicates if download asset materials modal is visible
	 */
	downloadAssetMaterialsModalVisible: boolean;
	/**
	 * Indicates if upload asset materials modal is visible
	 */
	uploadAssetMaterialsModalVisible: boolean;
	/**
	 * Asset for materials modal
	 */
	assetIdForMaterialsModal: Option<string>
	/**
	 * Asset id provided to asset history modal
	 */
	assetIdForHistoryModal: Option<string>
}

type Props = RouteComponentProps<any>;

const defaultSort = option(new SortColumnModel("1d2d01bf-7f6d-4b7e-b5b0-0f58eeebefbb", "updateDate", false));

class AssetWorkspaceContainer extends React.Component<Props, IState> {
	constructor(props: Props) {
		super(props);

		this.state = {
			uploadModalVisible: false,
			downloadAssetMaterialsModalVisible: false,
			uploadAssetMaterialsModalVisible: false,
			assetIdForHistoryModal: none,
			assetIdForMaterialsModal: none
		};
		this.openUploadAssetsModal = this.openUploadAssetsModal.bind(this);
		this.closeUploadAssetsModal = this.closeUploadAssetsModal.bind(this);
		this.openDownloadAssetMaterialsModal = this.openDownloadAssetMaterialsModal.bind(this);
		this.closeDownloadAssetMaterialsModal = this.closeDownloadAssetMaterialsModal.bind(this);
		this.openUploadAssetMaterialsModal = this.openUploadAssetMaterialsModal.bind(this);
		this.closeUploadAssetMaterialsModal = this.closeUploadAssetMaterialsModal.bind(this);
		this.showHistoryModal = this.showHistoryModal.bind(this);
		this.closeHistoryModal = this.closeHistoryModal.bind(this);
	}

	render() {
		return (
			<>
				<WorkspaceContainer workspaceName={WorkspaceName.Assets}
									wildcardFilterColumnType={WildcardFilterColumnType.Assets}
									onRowClick={(rowId: string) => this.props.history.push(Routes.EditAsset(rowId))}
									rowToId={(row) => row.id}
									renderButton={this.renderActionBtn}
									sortable
									defaultSort={defaultSort}
									lastColumnWidth={350}
									lastColumn={this.renderColumnBtn}
				/>
				{this.state.uploadModalVisible &&
				<UploadAssetModal onClose={this.closeUploadAssetsModal}/>}
				{this.state.downloadAssetMaterialsModalVisible &&
				<DownloadAssetMaterialsModal onClose={this.closeDownloadAssetMaterialsModal} placeholder={"Select merchant"}/>
				}
				{this.state.uploadAssetMaterialsModalVisible &&
				<UploadAssetMaterialsModal onClose={this.closeUploadAssetMaterialsModal} placeholder={"Select merchant"}/>
				}
				{this.state.assetIdForMaterialsModal.map(assetId =>
					<AssetMaterialsBreakdownModal assetId={assetId} onClose={this.closeAssetMaterialsBreakdownModal}/>).orNull}
				{this.state.assetIdForHistoryModal.map(assetId =>
					<AssetHistoryModal assetId={assetId}
									   onClose={this.closeHistoryModal}/>
				).orNull}
			</>
		)
	}

	renderColumnBtn = (row: CellInfo) => {
		const assetId = row.original.id;
		return (
			<>
				<ButtonPrimary
					label="Materials breakdown"
					onClick={() => this.renderMaterialsBreakdownModal(row)}
					customStyles={{marginRight: "10px"}}
					variant={"burgundy"}/>
				<ButtonTertiary label={"History"}
								onClick={() => this.showHistoryModal(assetId)}/>
			</>
		)
	};

	renderActionBtn = () => {
		return (
			<div>
				<ButtonPrimary onClick={this.goToAssetCreation}
							   label={"Create Asset"}
							   variant={"burgundy"}/>
				<ButtonPrimary onClick={this.downloadAssetsXls}
							   label={"Download Assets"}
							   variant={"burgundy"}
							   customStyles={{marginLeft: "10px"}}/>
				<ButtonPrimary onClick={this.openUploadAssetsModal}
							   label={"Upload Assets"}
							   variant={"burgundy"}
							   customStyles={{marginLeft: "10px"}}/>
				<ButtonPrimary onClick={this.openDownloadAssetMaterialsModal}
							   label={"Download Asset Materials"}
							   variant={"burgundy"}
							   customStyles={{marginLeft: "10px"}}/>
				<ButtonPrimary onClick={this.openUploadAssetMaterialsModal}
							   label={"Upload Asset Materials"}
							   variant={"burgundy"}
							   customStyles={{marginLeft: "10px"}}/>
			</div>
		)
	};

	renderMaterialsBreakdownModal = (row: any) => {
		this.setState({assetIdForMaterialsModal: option(row.original.id)})
	};

	goToAssetCreation = () => {
		this.props.history.push(Routes.AddAsset);
	};

	closeAssetMaterialsBreakdownModal = () => {
		this.setState({assetIdForMaterialsModal: none});
	};

	closeUploadAssetMaterialsModal() {
		this.setState({uploadAssetMaterialsModalVisible: false});
	}

	closeDownloadAssetMaterialsModal() {
		this.setState({downloadAssetMaterialsModalVisible: false});
	}

	closeUploadAssetsModal() {
		this.setState({uploadModalVisible: false});
	}

	openUploadAssetsModal() {
		this.setState({uploadModalVisible: true});
	}

	openDownloadAssetMaterialsModal() {
		this.setState({downloadAssetMaterialsModalVisible: true});
	}

	openUploadAssetMaterialsModal() {
		this.setState({uploadAssetMaterialsModalVisible: true});
	}

	showHistoryModal(assetId: string) {
		this.setState({assetIdForHistoryModal: option(assetId)});
	}

	closeHistoryModal() {
		this.setState({assetIdForHistoryModal: none});
	}

	downloadAssetsXls() {
		api.instance.assetApi.downloadAssets().catch(() => notifyBugsnagAndShowToast("Cannot download assets", "Asset download"));
	}
}

export default withRouter(AssetWorkspaceContainer);
